import React from "react";
import "./Event_Registration.css";
import Event_Banner from "./event_banner/Event_Banner";
import Near_You from "./near_you/Near_You";
import Explore_All from "./explore_all/Explore_All";

const Event_Registration = () => {
  return (
    <section className="Event_Registration">
      <Event_Banner />
      <Near_You />
      <Explore_All />
    </section>
  );
};

export default Event_Registration;
